import { pins, signals as signalsService } from 'services'
import { normalizeSignals, normalizeOutputPins } from 'schemas/feature'
import { createAction } from 'actions/utils'

export const UPDATE_SELECTED_INPUT = 'UPDATE_SELECTED_INPUT'
export const updateSelectedInput = createAction(UPDATE_SELECTED_INPUT, [
  'uri',
  'subType',
  'configuredInputs',
  'defaultInputConfigs',
  'inputUriOrFloatingCircuit',
])

export const SWITCH_INPUT_TYPE = 'SWITCH_INPUT_TYPE'
// 'queryType' is optional
export const switchInputType = createAction(SWITCH_INPUT_TYPE, [
  'queryUri',
  'subType',
  'options',
  'queryType',
])

export const UPDATE_INPUT_CONFIGS = 'UPDATE_INPUT_CONFIGS'
export const updateInputConfigs = (inputConfig, conditionUris) => ({
  type: UPDATE_INPUT_CONFIGS,
  conditionUris,
  inputConfig,
})

export const UPDATE_TEM_SWITCH_CUSTOM_DESCRIPTION =
  'UPDATE_TEM_SWITCH_CUSTOM_DESCRIPTION'
export const updateTemSwitchCustomDescription = createAction(
  UPDATE_TEM_SWITCH_CUSTOM_DESCRIPTION,
  ['uri', 'customDescription', 'conditionUris']
)

export const PINS_RECEIVED = 'PINS_RECEIVED'
export const PINS_NOT_RECEIVED = 'PINS_NOT_RECEIVED'
export const REQUESTING_PINS = 'REQUESTING_PINS'
export const getPins = () => (dispatch) => {
  dispatch({
    type: REQUESTING_PINS,
  })
  return pins
    .get()
    .then((outputs) => {
      const {
        entities: { outputPins: normalizedOutputPins },
      } = normalizeOutputPins(outputs)
      dispatch({
        outputPins: normalizedOutputPins,
        type: PINS_RECEIVED,
      })
    })
    .catch((err) => dispatch({ type: PINS_NOT_RECEIVED, err }))
}

export const SIGNALS_RECEIVED = 'SIGNALS_RECEIVED'
export const SIGNALS_NOT_RECEIVED = 'SIGNALS_NOT_RECEIVED'
export const REQUESTING_SIGNALS = 'REQUESTING_SIGNALS'
export const getSignals = () => (dispatch) => {
  dispatch({
    type: REQUESTING_SIGNALS,
  })
  return (
    signalsService
      .get()
      .then((signals) => {
        const {
          entities: { signals: normalizedSignals },
        } = normalizeSignals(signals)
        dispatch({
          signals: normalizedSignals,
          type: SIGNALS_RECEIVED,
        })
      })
      // todo: figure out if/how the UI should handle this.
      .catch((err) => dispatch({ type: SIGNALS_NOT_RECEIVED, err }))
  )
}

export const REQUESTING_SUBGROUPS = 'REQUESTING_SUBGROUPS'
export const SUBGROUPS_RECEIVED = 'SUBGROUPS_RECEIVED'
export const SUBGROUPS_NOT_RECEIVED = 'SUBGROUPS_NOT_RECEIVED'
export const getSubGroups = createAction(REQUESTING_SUBGROUPS)

export const ADD_LOGIC_NODE_TO_INPUT = 'ADD_LOGIC_NODE_TO_INPUT'
export const addLogicNodeToInput = createAction(ADD_LOGIC_NODE_TO_INPUT, [
  'nodeType',
  'nextIndex',
  'conditionUri',
])

export const ADD_EXISTING_LOGIC_NODE_TO_QUERY =
  'ADD_EXISTING_LOGIC_NODE_TO_QUERY'
export const addExistingLogicNodeToQuery = createAction(
  ADD_EXISTING_LOGIC_NODE_TO_QUERY,
  ['node', 'condition']
)
